export default __webpack_public_path__ + "static/media/tat_img7.80163645.webp";